import ControlledInformationCard from './ControlledInformationCard.component';

export default ControlledInformationCard;
